import { initContract } from '@ts-rest/core'
import { LogConsentRequestSchema, LogConsentResponseSchema } from '../schemas/consent'
import { defaultErrorResponses } from './errors'

const c = initContract()

/**
 * Consent Contract - records a visitor's cookie / GDPR consent choice.
 *
 * Auth is OPTIONAL. Pre-auth visitors post with `session_id` only (user_id null on server).
 * Post-auth visitors include a bearer token and the server associates the log with their user_id.
 */
export const consentContract = c.router({
  logConsent: {
    method: 'POST',
    path: '/v1/consent/cookies',
    body: LogConsentRequestSchema,
    responses: {
      201: LogConsentResponseSchema,
      ...defaultErrorResponses,
    },
    metadata: {
      auth: false,
      summary: 'Log a cookie consent choice',
      description:
        'Records an anonymous or authenticated visitor cookie consent choice.',
    },
  },
})
